import { TemplateKey } from "PFApp/constants/templates";
import { Modal } from "PFComponents/modal";
import { Activity, AuditRole, Engagement, Role } from "PFCore/types";
import { Trans, useTranslation } from "react-i18next";
import { Link } from "react-router";

import css from "./close_confirm_modal.module.scss";
import { CloseConfirmModalBookingsToggle } from "./parts/close_confirm_modal_bookings_toggle";
import { CloseConfirmModalHeader } from "./parts/close_confirm_modal_header";
import { CloseConfirmModalReasonSelect } from "./parts/close_confirm_modal_reason_select";
import { useCloseConfirmModal } from "./use_close_confirm_modal";

type CloseConfirmModalProps = {
  activity: Activity | AuditRole | Role | Engagement;
  handleClose: VoidFunction;
  handleSuccess: VoidFunction;
  type: TemplateKey;
};

export const CloseConfirmModal = ({ activity, type, handleClose, handleSuccess }: CloseConfirmModalProps) => {
  const { t } = useTranslation("activities");

  const {
    activity: normalizedActivity,
    template,
    activityType,
    isRoleOrAuditRole,
    isAuditRole,
    filledOrBooked,
    vacancies,
    shortlists,
    isShortlistsFetching,
    closeOptions,
    selectedReason,
    setSelectedReason,
    deleteBookings,
    setDeleteBookings,
    closeVacanciesAndActivity,
    openVacancies,
    hasOpenVacancies,
    isSubmitDisabled
  } = useCloseConfirmModal({ activity, type, handleSuccess });

  if (!vacancies && isRoleOrAuditRole) {
    return null;
  }

  return (
    <Modal
      title={t("closeActivity.close", { activityType })}
      onOK={isSubmitDisabled ? undefined : closeVacanciesAndActivity}
      onClose={handleClose}
      labelOK={
        hasOpenVacancies && isRoleOrAuditRole
          ? t("closeActivity.goToVacancies", {
              activityType,
              count: openVacancies
            })
          : t("closeActivity.close", { activityType })
      }
      kindOK="danger"
      showCancelButton={false}
    >
      <CloseConfirmModalHeader
        isVisible={hasOpenVacancies}
        templateKey={template?.key}
        openVacancies={openVacancies}
      />
      <div className={css.text}>
        {hasOpenVacancies ? (
          <Trans
            i18nKey={`closeActivity.with_vacancies.text.${template?.key}` as any}
            t={t}
            components={[
              <Link
                key={0}
                onClick={() => handleClose()}
                to={`/activities/${normalizedActivity.id}/vacancies`}
              />
            ]}
          />
        ) : (
          t("closeActivity.text", { activityType })
        )}
        <CloseConfirmModalReasonSelect
          isVisible={hasOpenVacancies && isRoleOrAuditRole}
          closeOptions={closeOptions}
          selectedReason={selectedReason}
          onSelectedReasonChange={setSelectedReason}
        />
        <CloseConfirmModalBookingsToggle
          isVisible={filledOrBooked && isAuditRole}
          activityType={activityType}
          isShortlistsFetching={isShortlistsFetching}
          hasShortlists={!!shortlists}
          deleteBookings={deleteBookings}
          onDeleteBookingsChange={setDeleteBookings}
        />
      </div>
    </Modal>
  );
};
